<template>
    <div class="address">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">
                    <span v-if="address.id">{{address.full_address}}</span>
                    <span v-else>Create Address</span>
                </a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <form @submit.prevent="saveModel" accept-charset="UTF-8" novalidate="novalidate">
                    <fieldset>
                        <legend>Address</legend>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('Address[address]')}">
                            <label for="address-address">Address</label>

                            <input id="address-address"
                                   v-validate="'required'"
                                   v-model="address.address"
                                   name="Address[address]"
                                   type="text"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('Address[address]')" class="help-block">
                                {{ errors.first('Address[address]') }}
                            </span>
                        </div>

                        <div class="form-group has-feedback"
                             :class="{'has-error': errors.has('Address[address_2]')}">
                            <label for="address-address-2">Address 2</label>

                            <input id="address-address-2"
                                   v-model="address.address_2"
                                   name="Address[address_2]"
                                   type="text"
                                   class="form-control"
                                   aria-required="true">

                            <span v-show="errors.has('Address[address_2]')" class="help-block">
                                {{ errors.first('Address[address_2]') }}
                            </span>
                        </div>

                        <div class="row">
                            <div class="col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('Address[city]')}">
                                <label for="address-city">City</label>

                                <input id="address-city"
                                       v-validate="'required'"
                                       v-model="address.city"
                                       name="Address[city]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('Address[city]')" class="help-block">
                                    {{ errors.first('Address[city]') }}
                                </span>
                            </div>

                            <div class="col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('Address[state]')}">
                                <label for="address-state">State</label>

                                <select id="address-state"
                                        v-validate="'required'"
                                        v-model="address.state"
                                        name="Address[state]"
                                        class="form-control">
                                    <option value="">-</option>
                                    <option v-for="(state, abbreviation) in states" :value="abbreviation">
                                        {{state}}
                                    </option>
                                </select>

                                <span v-show="errors.has('Address[state]')" class="help-block">
                                    {{ errors.first('Address[state]') }}
                                </span>
                            </div>

                            <div class="col-sm-4 form-group has-feedback"
                                 :class="{'has-error': errors.has('Address[postal_code]')}">
                                <label for="address-postal-code">Postal Code</label>

                                <input id="address-postal-code"
                                       v-validate="'required'"
                                       v-model="address.postal_code"
                                       name="Address[postal_code]"
                                       type="text"
                                       class="form-control"
                                       aria-required="true">

                                <span v-show="errors.has('Address[postal_code]')" class="help-block">
                                    {{ errors.first('Address[postal_code]') }}
                                </span>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-xs-5 form-group">
                                <button type="button" class="btn btn-sm btn-warning"
                                        v-if="address.id"
                                        @click="deleteModel"
                                        :disabled="loading">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div class="col-xs-7 form-group text-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save Address
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    const {states} = require( '../constants.json' );

    export default {
        props: {
            modalId: {
                default: () => {
                    return Math.random().toString();
                },
                type: String
            },

            addressId: {
                type: String,
                default: null
            },

            addressableId: {
                type: String,
                required: true
            },

            addressableType: {
                type: String,
                required: true
            },

            dependentKey: {
                type: String,
                default: null
            },

            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                address: {
                    address: null,
                    address_2: null,
                    city: null,
                    state: null,
                    postal_code: null,
                },

                dependentModelUrls: {
                    'App\\Contact': '/api/contacts',
                    'App\\Project': '/api/projects',
                    'App\\Property': '/api/properties',
                    'App\\SSID': '/api/ssids',
                    'App\\User': '/api/users',
                },

                states: states,
            };
        },

        computed: {
            dependentModelUrl(){
                return this.dependentModelUrls[ this.addressableType ] + '/' + this.addressableId;
            },

            dependentData(){
                var addressableKey = this.addressableType.replace( "App\\", "" );
                var data = {};
                data[ addressableKey ] = {};
                data[ addressableKey ][ this.dependentKey ] = this.address.id;

                return data;
            },

            dependentNullData(){
                var addressableKey = this.addressableType.replace( "App\\", "" );
                var data = {};
                data[ addressableKey ] = {};
                data[ addressableKey ][ this.dependentKey ] = null;

                return data;
            }
        },

        watch: {
            addressId(){
                if( this.addressId ){
                    this.init();
                }
                else {
                    this.resetData();
                }
            }
        },

        methods: {
            /** Address **/
            loadAddress(){
                var url = '/api/addresses/' + this.address.id;

                return axios.get( url )
                    .then( ( response ) => {
                        var address = response.data.Address;

                        this.$set( this, 'address', address );
                    } );
            },

            saveModel(){
                var url = '/api/addresses';

                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            var address = this.address;
                            var promise;

                            this.loading = true;

                            if( this.address.id ){
                                promise = axios.put( url + '/' + this.address.id, {
                                    Address: address
                                } );
                            }
                            else {
                                address.addressable_type = this.addressableType;
                                address.addressable_id = this.addressableId;

                                promise = axios.post( url, {
                                    Address: address
                                } );
                            }

                            promise
                                .then( ( result ) => {
                                    if( !this.address.id ){
                                        this.address = result.data.Address;
                                    }

                                    if( this.dependentKey ){
                                        return this.saveDependentModel();
                                    }
                                } )
                                .then( () => {
                                    return this.loadAddress();
                                } )
                                .then( () => {
                                    this.afterSave();
                                    this.$modal.hide( this.modalId );

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved Address',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( this.$root.handleErrors );
                        }
                    } );
            },

            saveDependentModel(){
                return axios.put( this.dependentModelUrl, this.dependentData );
            },

            saveNullDependentModel(){
                return axios.put( this.dependentModelUrl, this.dependentNullData );
            },

            deleteModel(){
                this.loading = true;

                return axios.delete( '/api/addresses/' + this.address.id )
                    .then( () => {
                        if( this.dependentKey ){
                            return this.saveNullDependentModel();
                        }
                    } )
                    .then( () => {
                        this.resetData();
                        this.afterSave();

                        this.$modal.hide( this.modalId );

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Address',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            /** Hooks **/
            beforeClose(){
                if( this.addressId === null ){
                    this.resetData();
                }

                this.$emit( 'before-close' );
            },

            init(){
                var promise = Promise.resolve();
                this.loading = true;

                if( this.addressId ){
                    this.address.id = this.addressId;

                    promise.then( () => {
                        return this.loadAddress();
                    } );
                }

                promise
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            /** Instance Functions **/
            openModal(){
                this.$modal.show( this.modalId );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            }
        }
    }
</script>
